import { AppState } from '../reducers';
import { createSelector } from 'reselect';

const selectProductFilter = (state: AppState) => state.productFilter;

export const getFilteredProducts = createSelector(
  selectProductFilter,
  filter => ({
    filteredProducts: filter.filteredProducts
  })
);

export const getProductFilters = createSelector(
  selectProductFilter,
  filter => ({
    productsFilters: filter
  })
);
